import { getReq } from "./instance";

export const getManufacturer = async (manufacturerId: string, params = {}) => {
  return getReq(`/Manufacturer/${manufacturerId}`, params);
};
